var $63eb283d27decb4d$exports = {};
const $63eb283d27decb4d$var$inputsController = document.querySelector(".js-inputController");
const $63eb283d27decb4d$var$billInput = document.querySelector(".js-billInput");
const $63eb283d27decb4d$var$peopleInput = document.querySelector(".js-peopleInput");
const $63eb283d27decb4d$var$customInput = document.querySelector(".js-custom");
const $63eb283d27decb4d$var$tipXPerson = document.querySelector(".js-tipxperson");
const $63eb283d27decb4d$var$totalXPerson = document.querySelector(".js-totalxperson");
const $63eb283d27decb4d$var$resetButton = document.querySelector(".btn-reset");
/**********************Event Listeners***************************/ $63eb283d27decb4d$var$inputsController.addEventListener("click", (e)=>{
    const targetType = e.target.getAttribute("type");
    // We get the number of the input without "%" and in Integer
    if (targetType === "radio") {
        const childTip = e.target.parentElement.querySelector(".tip-percentage");
        const tipNum = parseInt(childTip.innerHTML.slice(0, -1), 10);
        $63eb283d27decb4d$var$calculateTotal(tipNum / 100);
    } else if (targetType === "number") {
        // Uncheck all other inputs
        $63eb283d27decb4d$var$clearAllInputs();
        $63eb283d27decb4d$var$customInput.addEventListener("input", ()=>{
            $63eb283d27decb4d$var$calculateTotal(parseInt($63eb283d27decb4d$var$customInput.value, 10));
        });
    }
});
$63eb283d27decb4d$var$resetButton.addEventListener("click", ()=>{
    $63eb283d27decb4d$var$billInput.value = "";
    $63eb283d27decb4d$var$peopleInput.value = "";
    $63eb283d27decb4d$var$customInput.value = "";
    $63eb283d27decb4d$var$tipXPerson.innerHTML = "$0.00";
    $63eb283d27decb4d$var$totalXPerson.innerHTML = "$0.00";
    $63eb283d27decb4d$var$clearAllInputs();
});
/*********************Functions*************************/ const $63eb283d27decb4d$var$calculateTotal = function(num) {
    const peopleInputInt = parseInt($63eb283d27decb4d$var$peopleInput.value, 10);
    const billInputInt = parseInt($63eb283d27decb4d$var$billInput.value, 10);
    // It is NaN when there is no input in Number of People
    if (isNaN(peopleInputInt) || isNaN(num)) {
        console.log("Number of People is empty or Custom num is empty");
        $63eb283d27decb4d$var$tipXPerson.innerHTML = "$0.00";
        $63eb283d27decb4d$var$totalXPerson.innerHTML = "$0.00";
    } else {
        const totalTip = billInputInt * num / peopleInputInt;
        const totalPerson = totalTip + billInputInt / peopleInputInt;
        if (peopleInputInt === 0) return $63eb283d27decb4d$var$setErrorFor("cannot be 0");
        $63eb283d27decb4d$var$tipXPerson.innerHTML = "$" + totalTip.toFixed(2);
        $63eb283d27decb4d$var$totalXPerson.innerHTML = "$" + totalPerson.toFixed(2);
        $63eb283d27decb4d$var$setSuccess();
    }
};
// Uncheck all % Inputs
function $63eb283d27decb4d$var$clearAllInputs() {
    const allTipPercentage = $63eb283d27decb4d$var$inputsController.querySelectorAll("input");
    allTipPercentage.forEach((el)=>{
        el.checked = false;
    });
}
function $63eb283d27decb4d$var$setErrorFor(message) {
    const formControl = document.querySelector(".form-control");
    const small = formControl.querySelector("small");
    formControl.className = "splitter__people form-control error";
    small.innerText = message;
    $63eb283d27decb4d$var$tipXPerson.innerHTML = "$0.00";
    $63eb283d27decb4d$var$totalXPerson.innerHTML = "$0.00";
}
function $63eb283d27decb4d$var$setSuccess() {
    const formControl = document.querySelector(".form-control");
    formControl.classList.remove("error");
}


//# sourceMappingURL=index.c6bcc8b3.js.map
